/* eslint-disable max-len */
/* eslint-disable prettier/prettier */
/* eslint-disable spaced-comment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useQuery, useQueryClient } from "react-query";
import LabelsPicker from "../../../../Common/components/Inputs/LabelsPicker/LabelsPicker/LabelsPicker";
import prettyPrint from "../../../../Retrofit/utils/CorrespondingCrossComponent/prettyPrint";
import {
  clearBundlesToCompare,
  saveApplicationDataDependencies,
  selectRetrofitConfiguration,
  selectFiltersInit,
  selectFiltersWrapperOpened,
  selectGearboxSynchronizedFilters,
  selectPossibleFiltersValues,
  setGearboxSynchronizedFilters,
  setSavedGearboxDependenciesPayload,
  showSnackbar,
  setAxisFilters,
  selectSavedGearboxDependenciesPayload
} from "../../../../Retrofit/store/slices/retrofit";
import Button from "../../../../Common/components/Buttons/Button/Button";
import { logEvent, syncFiltersDependencies } from "../../../../Common/utils/api/api";
import Spinner from "../../../../Common/components/Icons/Spinner/Spinner";
import { formatConnectorType, formatMotorEncoder, formatShaftEnd, formatNbPhases } from "./utils";
import t from "../../../../Common/utils/translation/translator";
import { tData } from "../../../../Common/utils/translation/dataUtils";
import SelectionRange from "../../../../Common/components/Inputs/SelectionRange/SelectionRange";
import MotorFilters from "./MotorFilters";
import { selectConfigurationType, selectEventsData } from "../../../../Common/store/slices/common";
import { selectIntegratedDrivesConfiguration } from "../../../../IntegratedDrives/store/slices/integrated_drives";
import { selectSelectedAxis } from "../../../../Cartesian/store/slices/cartesian";
import { getNominalToqueMultiplicator } from "../../../../Common/utils/func.util";

const GearboxFilters = ({ closeTab, filters, axisId, ...props }) => {
  const possibleGearboxFiltersValues = useSelector(selectPossibleFiltersValues)?.gearbox;
  const retrofitConfiguration = useSelector(selectRetrofitConfiguration);
  const integratedDrivesConfiguration = useSelector(selectIntegratedDrivesConfiguration);
  const configurationType = useSelector(selectConfigurationType);
  const synchronizedGearboxFilters = useSelector(selectGearboxSynchronizedFilters);
  const storedApplicationDataDependencies = useSelector(
    (state) => state.retrofit.configuration?.configData?.axes?.find((a) => a.id === axisId)?.axisState?.dependencies
  );
  const applicationDataFiltersValues = useSelector(selectPossibleFiltersValues)?.applicationData;
  const eventsData = useSelector(selectEventsData);
  const filtersWrapperOpened = useSelector(selectFiltersWrapperOpened);
  const filtersInit = useSelector(selectFiltersInit);
  const savedDependenciesPayload = useSelector(selectSavedGearboxDependenciesPayload);
  const dispatch = useDispatch();

  const configuration = integratedDrivesConfiguration || retrofitConfiguration;
  const isIntegratedDrivesConfiguration = integratedDrivesConfiguration !== null;
  const chipFilters = ["externalDiameter", "productOrComponentType", "ratio"];
  const queryClient = useQueryClient();
  
  const [data, setData] = useState(filters?.gearboxFilter);
  const driveFilters = useState(filters?.driveFilter);
  const motorFilters = useState(filters?.motorFilter);
  const appDataFilters = useState(filters?.applicationDataFilter);
  const [withGearbox, setWithGearbox] = useState(motorFilters?.withGearbox || data?.enabled);
  const [currentAxis, setCurrentAxis] = useState(null);
  const [highlightErrors, setHighlightErrors] = useState(false);
  const [syncronizedFilters, setSyncronizedFilters] = useState(
    isIntegratedDrivesConfiguration ? {
      ...possibleGearboxFiltersValues,
      reductionRatio: possibleGearboxFiltersValues?.ratio,
     } :
    JSON.parse(JSON.stringify(synchronizedGearboxFilters))
  );
  const [percentage, setPercentage] = useState(0);
  const [filterLaunchingSync, setFilterLaunchingSync] = useState(null);
  const [isFetchingOrLoading, setIsFetchingOrLoading] = useState(false);
  const [firstOccurence, setFirstOccurence] = useState(true);

  console.log("filters =>", filters);
  console.log("appDataFilters =>", appDataFilters);

  const handleApplyFilters = () => {
    if (withGearbox && (!data?.productOrComponentType || data?.productOrComponentType?.length === 0)) {
      setHighlightErrors(true);
      dispatch(showSnackbar({ id: "MANDATORY_FIELDS" }));
      return;
    }
    // filters of the current axis
    const newFilters = {
      ...filters,
      gearboxFilter: data
    };
    // onApplyFilters(axisId, newFilters); 
    dispatch(setAxisFilters({ axisId, filters: newFilters }))
    dispatch(clearBundlesToCompare());
    closeTab();
  };

  const correspondingAttributeName = (attribute) => {
    switch (attribute) {
      case "ratio":
        return "reductionRatio";
      default:
        return attribute;
    }
  };

  // Function to update the loader progress
  const updateLoaderProgress = (currentProgress, totalRequests) => {
    const percentageProgress = ((currentProgress / totalRequests) * 100).toFixed(2);
    setPercentage(percentageProgress);
    console.log(percentage);
  };

  const {
    refetch: execSyncFilters,
    isFetching: isFetchingSyncFilters,
    isLoading: isLoadingSyncFilters
  } = useQuery(
    "SYNC_GEARBOX_FILTERS",
    async () => {
      console.log("executing sync gearbox filters");
      setIsFetchingOrLoading(true);
      const totalChipFiltersRequests = chipFilters.length;
      const totalRequests = totalChipFiltersRequests + 1; // (app data)

      let completedRequests = 0;

      const handleRequestCompletion = () => {
        completedRequests += 1;
        updateLoaderProgress(completedRequests, totalRequests);
      };

      const handlePercentageCompletion = () => {
        updateLoaderProgress(totalRequests, totalRequests);
        setTimeout(() => {
          updateLoaderProgress(0, totalRequests);
        }, 100);
      };
      try {
        const motorEncoderFormatted = formatMotorEncoder(motorFilters?.motorEncoder);
        const shaftEndFormatted = formatShaftEnd(motorFilters?.shaftEnd);
        const connectorTypeFormatted = formatConnectorType(motorFilters?.connectorType);
        const nbPhasesFormatted = formatNbPhases(driveFilters?.nbPhases);

        const commonPayload = {
          device: "ALL",
          criteria: {
            locale: window.msizerConfiguration?.locale || "en-WW",
            applicationData: configurationType !== "INTEGRATED_DRIVES" ? {
              nominalSpeed: parseFloat(appDataFilters.nominalSpeed),
              nominalTorque: appDataFilters.nominalTorque
                ? {
                    min: parseFloat(appDataFilters?.nominalTorque),
                    max: parseFloat(appDataFilters?.nominalTorque) * getNominalToqueMultiplicator(configurationType)
                  }
                : null,
              inertia: parseFloat(appDataFilters.loadInertia),
              length: parseFloat(appDataFilters.maxLength),
              withGearbox: withGearbox,
              nominalTorqueOfMotor: motorFilters?.nominalTorque,
              nominalSpeedOfMotor: motorFilters?.nominalSpeed
            }: undefined,
            drive: configurationType !== "INTEGRATED_DRIVES" ? {
              type: driveFilters?.driveType || [],
              communicationInterfaces: driveFilters?.driveInterface || [],
              outputCurrents: driveFilters?.outputCurrent || [],
              nominalPower: driveFilters?.nominalPower || [],
              switchingFreq: driveFilters?.switchingFreq || [],
              format: driveFilters?.format || [],
              nbPhases: nbPhasesFormatted,
              driveVoltages: driveFilters?.driveVoltages || []
            } : undefined,
            motor: configurationType !== "INTEGRATED_DRIVES" ? {
              type: motorFilters?.motorType || [],
              feedbackType: motorEncoderFormatted,
              connectorType: connectorTypeFormatted,
              ipProtection: motorFilters?.ipDegreeOfProtection || [],
              holdingBrake: motorFilters?.holdingBrake || [],
              shaftEnd: shaftEndFormatted,
              // length: motorFilters?.length,
              length: motorFilters?.motorLength
            } : undefined,
            gearbox: {
              productOrComponentType: withGearbox ? data?.productOrComponentType || [] : "",
              reductionRatio: withGearbox ? data?.ratio || [] : [],
              // torsionalBacklash: withGearbox
              //   ? data?.torsionalBacklash || []
              //   : [],
              torsionalBacklash: withGearbox
                ? data?.torsionalBacklash
                : {
                    min: 0,
                    max: Math.max(...possibleGearboxFiltersValues.torsionalBacklash)
                  },
              externalDiameter: withGearbox ? data?.externalDiameter || [] : []
            },
            integratedDrive: configurationType === "INTEGRATED_DRIVES" ? filters?.integratedDriveFilter
              : undefined
          }
        };
        // application Data payload
        let payload = {
          ...commonPayload,
          criteria: {
            ...commonPayload.criteria,
            step: "bundle"
          }
        };
        console.log("payload =>", payload);

        let newApplicationDataFilters = storedApplicationDataDependencies;

        const previousPayload = currentAxis?.axisState?.savedApplicationDataPayload;
        // check if the new payload is different from the previous one (to avoid useless calls)
        if (JSON.stringify(payload) !== JSON.stringify(previousPayload)) {
          // sync application data filters
          newApplicationDataFilters = await syncFiltersDependencies(configurationType, payload);
          newApplicationDataFilters = newApplicationDataFilters?.applicationData;
          dispatch(
            saveApplicationDataDependencies({
              axisId,
              dependencies: newApplicationDataFilters,
              appDataPayload: payload
            })
          );
        }
        handleRequestCompletion();
        // payload used for motor filters
        payload = {
          ...commonPayload,
          criteria: {
            ...commonPayload.criteria,
            step: "gearbox"
          }
        };

        if (savedDependenciesPayload && JSON.stringify(payload) === JSON.stringify(savedDependenciesPayload)) {
          console.log("payload is the same", payload);
          setIsFetchingOrLoading(false)
          handlePercentageCompletion();
          return synchronizedGearboxFilters;
        }

        const newFiltersPromise = syncFiltersDependencies(configurationType, payload);
        let chipFiltersPayloadsResultsPromise;
        if (withGearbox) {
          const chipFiltersPayloads = {};

          ["externalDiameter", "productOrComponentType", "ratio"].forEach(async (attribute) => {
            const payloadWithoutChipFilter = {
              ...payload,
              chipFilterName: attribute,
              criteria: {
                ...payload.criteria,
                gearbox: {
                  ...payload.criteria.gearbox,
                  [correspondingAttributeName(attribute)]: []
                }
              }
            };

            // save the chipFiltersPayloads in the state in order to do multiple async calls at the same time
            chipFiltersPayloads[correspondingAttributeName(attribute)] = payloadWithoutChipFilter;
          });

          chipFiltersPayloadsResultsPromise = Promise.all(
            Object.keys(chipFiltersPayloads).map(async (key) => {
              const result = await syncFiltersDependencies(configurationType, chipFiltersPayloads[key]);
              handleRequestCompletion();
              return { [key]: result };
            })
          ).then((results) => {
            const res = {};
            results.forEach((result) => {
              const key = Object.keys(result)[0];
              res[key] = result[key]?.gearbox?.[key];
            });
            return res;
          });
        }
        // Use Promise.all to execute both async operations concurrently
        const [newFilters, chipFiltersPayloadsResults] = await Promise.all([
          newFiltersPromise,
          chipFiltersPayloadsResultsPromise
        ]);
        setSyncronizedFilters({
          ...newFilters?.gearbox,
          ...chipFiltersPayloadsResults,
          ...filterLaunchingSync
        });
        setFilterLaunchingSync(null);
        dispatch(setGearboxSynchronizedFilters(JSON.parse(JSON.stringify(newFilters?.gearbox))));
        dispatch(setSavedGearboxDependenciesPayload(payload));
        handlePercentageCompletion();
        setIsFetchingOrLoading(false)
        return newFilters;
      } catch (error) {
        console.error("ERR", error.response?.status);

        dispatch(showSnackbar({ id: "ERROR_FILTERS" }));
        logEvent(eventsData.locale, eventsData.types.errorFilters, eventsData.tags.none, configuration?.configId);
        setIsFetchingOrLoading(false)
        handlePercentageCompletion();
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const getCartesianAxisSize = () => {
    const selectedAxis = useSelector(selectSelectedAxis);
    const axisSize = selectedAxis?.axis?.axisSize;
    return axisSize;
}


  const handleClearFilters = () => {
    // console.log("clear gearbox filters");
    const newFilters = {
      ...filters,
      gearboxFilter: {
        ...filtersInit.gearboxFilter,
        enabled: true ,
        family: undefined,
      ratio: [],
      externalDiameter: [],
      torsionalBacklash: {
        min: 0,
        max: Math.max(...possibleGearboxFiltersValues.torsionalBacklash)
      },
      productOrComponentType: []
      }
    };
    setData(newFilters.gearboxFilter);
  };

  const getGearBoxSize = (externalDiameter) => {
    if (configurationType === "RETROFIT") {
      return externalDiameter;
    }

    const axisSize = getCartesianAxisSize();
    if (axisSize==="1") {
      return [0];
    }
    if (axisSize==="2") {
      return [60];
    }
    if (axisSize==="3") {
      return [80];
    }
    if (axisSize==="4") {
      return [120];
    }
  }

  useEffect(() => {
    const axisFromConfiguration = configuration?.configData?.axes?.find((a) => a.id === axisId);
    setCurrentAxis(axisFromConfiguration);
  }, [configuration]);

  useEffect(() => {
      if (data && !firstOccurence && filtersWrapperOpened === "GEARBOX" && withGearbox) {
        // console.log("syncronize gearbox filters, data =>", data);
        queryClient.cancelQueries("SYNC_DRIVE_FILTERS");
        queryClient.cancelQueries("SYNC_MOTOR_FILTERS");
          execSyncFilters(); 
  
          const newFilters = {
            ...filters,
            gearboxFilter: data
          };
          dispatch(setAxisFilters({ axisId, filters: newFilters }));
  
          setWithGearbox(withGearbox || data?.enabled);
      } else {
        setFirstOccurence(false);
      }
    }, [data, filtersWrapperOpened]);

  return (
    <>
      <div className="GearboxFilters relative">
        <div
          // use the percentage for the width
          className="h-1 rounded bg-primary transition-all duration-100"
          style={{
            width: `${percentage}%`
          }}
        />
        <div
          className={`bg-gray-50 backdrop-blur-xs bg-opacity-50 h-full w-full top-0 left-0 absolute flex items-center justify-center z-20 ${
            !(isFetchingSyncFilters || isLoadingSyncFilters || isFetchingOrLoading || !data) && "hidden"
          }`}
        >
          <Spinner id="loading_spinner" />
        </div>
        <div className="md:flex justify-end hidden">
          <span
            onClick={handleClearFilters}
            className={`text-secondary text-sm px-2 py-1 cursor-pointer hover:underline select-none
              ${withGearbox ? "" : "invisible-element"}`}
          >
            {t("msizer.ui.filters.clear")}
          </span>
        </div>
        <div className="md:grid grid-cols-3 space-x-2 divide-x-2 divide-gray-100 divide-solid">
          <div className="p-2 space-y-5">
            {!isIntegratedDrivesConfiguration && <MotorFilters 
            filters={filters}
            filterToDisplay="gearboxToggle" gearboxFiltersProp={data}
            onApplyFilters={handleApplyFilters}
                  axisId={axisId}
                                                 />}
            <div className={`space-y-5 ${!withGearbox ? "blur-sm pointer-events-none" : ""}`}>
              <LabelsPicker
                singleChoice
                label={t("msizer.ui.gearbox_filters.product_type")}
                required
                error={highlightErrors && (!data?.productOrComponentType || data?.productOrComponentType?.length === 0)}
                cols={2}
                options={[
                  // loop through all the possible values except null values
                  ...possibleGearboxFiltersValues.productOrComponentType
                    .filter((val) => val !== null)
                    .map((val) => ({
                      label: tData("gearbox", "product.component.type", val),
                      key: val
                    }))
                ]}
                selectedLabelsInit={data?.productOrComponentType}
                disabledLabels={possibleGearboxFiltersValues.productOrComponentType?.filter(
                  (val) => !syncronizedFilters?.productOrComponentType?.includes(val) || !syncronizedFilters
                )}
                onChange={(val) => {
                  // setFilterLaunchingSync({
                  //   productOrComponentType:
                  //     syncronizedFilters?.productOrComponentType
                  // });

                  console.log(val);
                  setData({ ...data, productOrComponentType: val });
                }}
                changeWithInit
              />

              <LabelsPicker
                idLabel="ext-diameter"
                label={t("msizer.ui.gearbox_filters.external_diameter")}
                cols={4}
                selectedLabelsInit={getGearBoxSize(data?.externalDiameter)}
                options={possibleGearboxFiltersValues.externalDiameter
                  .filter((val) => val !== null)
                  ?.sort((a, b) => a - b)
                  .map((val) => ({
                    label: prettyPrint("externalDiameter", val),
                    key: val
                  }))}
                //.map((val) => ({ label: val, key: val }))}
                disabledLabels={possibleGearboxFiltersValues.externalDiameter.filter(
                  (val) => !syncronizedFilters?.externalDiameter?.includes(val) || !syncronizedFilters
                )}
                // selectedLabelsInit={data.family}
                onChange={(val) => {
                  setData({ ...data, externalDiameter: val });
                }}
                changeWithInit
              />
            </div>
          </div>
          <div className={`p-2 space-y-5 ${!withGearbox ? "blur-sm pointer-events-none" : ""}`}>
            <LabelsPicker
              idLabel="reduc-ratio"
              label={t("msizer.ui.gearbox_filters.reduction_ratio")}
              cols={3}
              options={[
                // loop through all the possible values except null values
                ...possibleGearboxFiltersValues.ratio
                  .filter((val) => val !== null)
                  ?.sort((a, b) => a - b)
                  .map((val) => ({ label: `${val}:1`, key: val }))
              ]}
              selectedLabelsInit={data?.ratio}
              // disabledLabels is possibleGearboxFiltersValues.ratio array minus
              // syncronizedFilters?.reductionRatio values
              // , or empty array if syncronizedFilters is null
              disabledLabels={possibleGearboxFiltersValues.ratio.filter(
                (val) => !syncronizedFilters?.reductionRatio?.includes(val) || !syncronizedFilters
              )}
              onChange={(val) => {
                // setFilterLaunchingSync({
                //   reductionRatio: syncronizedFilters?.reductionRatio
                // });
                console.log(val);
                setData({ ...data, ratio: val });
              }}
              changeWithInit
            />
          </div>
          <div className={`p-2 space-y-5 ${!withGearbox ? "blur-sm pointer-events-none" : ""}`}>
            <SelectionRange
              label={t("msizer.ui.gearbox_filters.maximum_torsional_backlash")}
              min={0}
              // max={Math.max(
              //   ...possibleGearboxFiltersValues.torsionalBacklash
              // )}
              possibleMin={0}
              max={
                syncronizedFilters?.torsionalBacklash?.max
                // || Math.max(...possibleGearboxFiltersValues.torsionalBacklash)
              }
              possibleMax={syncronizedFilters?.torsionalBacklash?.max}
              maxSmallestValue={
                syncronizedFilters?.torsionalBacklash?.min
                // || Math.min(...possibleGearboxFiltersValues.torsionalBacklash)
              }
              step={1}
              minValueInit={data?.torsionalBacklash?.min}
              maxValueInit={data?.torsionalBacklash?.max}
              onChange={(min, max) => {
                setFilterLaunchingSync({
                  torsionalBacklash: {
                    min: syncronizedFilters?.torsionalBacklash?.min,
                    max: syncronizedFilters?.torsionalBacklash?.max
                  }
                });
                console.log(min, max);
                setData({
                  ...data,
                  torsionalBacklash: { min: 0, max }
                });
              }}
              changeWithInit
              minimumLocked
            />
          </div>
        </div>
      </div>
      <div className="flex justify-center space-x-2 pt-2">
        <div className="flex-1 px-2" />
        <div className="flex-1 px-2 flex gap-2 md:gap-0 justify-center">
          <qds-button
            id="select-filters-button-apply"
            {...(withGearbox && (!data?.productOrComponentType || data?.productOrComponentType?.length === 0) ? { disabled: "" } : {})}
            onClick={handleApplyFilters}
            text={t("msizer.ui.popup.button.apply")}
          >
            
          </qds-button>
          <Button onClick={handleClearFilters} border="blue" textColor="blue" large classes="md:hidden">
            {t("msizer.ui.filters.clear")}
          </Button>
        </div>
        <div className="flex-1 px-2" />
      </div>
    </>
  );
};

GearboxFilters.propTypes = {
  closeTab: PropTypes.func
};

GearboxFilters.defaultProps = {
  closeTab: () => {}
};

export default GearboxFilters;